import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import SimpleModal from "./Modal";
import Template from "./Template";
import Button from "./Button";
import { useAutoLogout } from "../AutoLogoutContext";
import { commonStrings } from "./StringBundle";
import { companyOptions } from "../utils/constant";


const CompanySelectorPopup = () => {
    const { companyPopupOpen, setCompanyPopupOpen, selectedCompanyName,
        setSelectedCompanyName, invokeSaveHandler } = useAutoLogout();
        
    const handleCloseCompanyPopup = () => {
        setCompanyPopupOpen(false);
    };

    const selectCompanyBody = () => (
        <Grid container direction="row">
            <Grid item xs={12} md={12} container direction="column">
                <Template payload={companySelectorPayload} />
            </Grid>
        </Grid>
    );

    const handleCompanyChange = (event, value) => {
        setSelectedCompanyName(value);
    };

    const companySelectorPayload = [
        {
            name: "company_name",
            label: commonStrings.company_name,
            type: "autocomplete",
            options: companyOptions,
            labelprop: "label",
            value: selectedCompanyName,
            onChange: handleCompanyChange,
            sm: 12,
            required: true,
        },
    ];

    return (
        <SimpleModal
            open={companyPopupOpen}
            handleClose={handleCloseCompanyPopup}
            isNew={true}
            size={"custom"}
            isFooter={true}
            footer={
                <Button
                    label={commonStrings.proceed}
                    onClick={invokeSaveHandler}
                    disabled={!selectedCompanyName}
                />
            }
            header={commonStrings.selectCompanyName}
            body={selectCompanyBody}
        />
    );
};

export default CompanySelectorPopup;